import { useBusinessServiceRequest } from '@ingenico/react-section-utils';
import { CustomIconWithSkeleton } from '@ingenico/react-ui/custom-icon-with-skeleton';
import deepEqual from 'fast-deep-equal';
import type { ReactNode } from 'react';
import { memo, useCallback, useEffect, useState } from 'react';
import { DeviceManagementService } from '../../domain/business/services/deviceManagement.service';

export interface DownloadLazyLogoProps {
  readonly name: string;
  readonly logoAssetId?: string;
  readonly width?: number | string;
  readonly height?: number | string;
}

function DownloadLazyLogoCtrl({ name, logoAssetId, width, height }: DownloadLazyLogoProps): ReactNode {
  const [logo, setLogo] = useState<string>('');

  const assetQuery = useBusinessServiceRequest(
    DeviceManagementService,
    useCallback(
      (deviceManagementService) => (logoAssetId ? deviceManagementService.downloadLogoByIdV2(logoAssetId) : null),
      [logoAssetId],
    ),
  );

  useEffect(() => {
    if (assetQuery.data) {
      setLogo(assetQuery.data);
    } else if (assetQuery.isError) {
      // Only to force to display the default logo image
      setLogo('NOT_A_VALID_IMG');
    }
  }, [assetQuery.data, assetQuery.isError]);

  return (
    <CustomIconWithSkeleton
      altLogo={`${name} logo`}
      lazyMode={!!logoAssetId}
      source={logo}
      height={height}
      width={width}
    ></CustomIconWithSkeleton>
  );
}
export const DownloadLazyLogo = memo(DownloadLazyLogoCtrl, deepEqual);
